// Vendor imports
const ReactRedux = require('react-redux')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const Portal = require('client-v2/common/components/portal')
const withCommonRoot = require('client-v2/common/components/root')
const AuthModal = require('client-v2/common/containers/auth-modal-v2/component-smart')
const tag = require('client-v2/common/utils/hyperscript')
// Entry imports
const IntoFooter = require('client-v2/into-landing/components/footer')
const DownloadLinks = require('client-v2/into-landing/containers/download-links/component-smart')
const IntoHeader = require('client-v2/into-landing/containers/header/component-smart')
const SMSModal = require('client-v2/into-landing/containers/sms-modal/component-smart')

const bem = BemEntity('LoggedOutLandingLayout')

function LoggedOutLandingLayout() {
  const { posterUrl, videoUrl } = ReactRedux.useSelector(state => state.video)
  return (
    tag('div', {
      className: bem.block()
    },
      tag(IntoHeader),
      tag('div', {
        className: bem.element('wrapper')
      },
        tag('div', {
          className: bem.element('page')
        },
          tag('video', {
            className: bem.element('video-player'),
            autoPlay: true,
            loop: true,
            /**
             * In some browsers (e.g. Chrome 70.0) autoplay does not work if no muted attribute is present.
             * This video clip should not play sound anyways, so muting the video should be safe.
             * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#Attributes
             */
            muted: true,
            playsInline: true,
            poster: posterUrl,
            src: videoUrl,
            'x-webkit-airplay': 'deny'
          }),
          tag('div', {
            className: bem.element('text')
          },
            tag('div', {
              className: bem.element('caption')
            },
              'The best media for you from across the web.'
            ),
            tag(DownloadLinks, {
              className: bem.element('download-links')
            })
          )
        ),
        tag(IntoFooter, {
          className: bem.element('footer')
        })
      ),
      Portal.toModalRoot(
        tag(AuthModal),
        tag(SMSModal)
      )
    )
  )
}

const wrappedComponent = withCommonRoot(LoggedOutLandingLayout)
module.exports = Object.assign(wrappedComponent, {
  // Export unwrapped component for testing purposes
  LoggedOutLandingLayout
})
